import { permissionConstant } from './constant';
import { helpers } from '../utils';

/**
 * '101**' + ['create_task','update_task','remove_task'] + 'create_task' => true (0)
 * '101**' + ['create_task','update_task','remove_task'] + 'update_task' => false (0)
 */
export const hasPermissionTransform = function(
    permissionValue: string,
    allPermissionKeys: string[],
    expectedPermissionKey: string | any
) {
    if (!allPermissionKeys) {
        return false;
    }
    const _expectedPermissionKey = helpers.isObject(expectedPermissionKey) ? expectedPermissionKey.key : expectedPermissionKey;
    const index = allPermissionKeys.indexOf(_expectedPermissionKey);
    return permissionValue && permissionValue[index] === permissionConstant.HAS_PERMISSION_MASK;
};

/**
 * expectedPermissionKeys: ['add_private_project', 'add_public_project']
 * allPermissionKeys: ['add_private_project', 'add_public_project', 'admin_public_project', 'admin_take_tag']
 * permissionValue: '1011'
 * 00** => false
 * 10** => true
 * 11** => true
 * ææçæéé¡¹å¶ä¸­åªè¦æä¸ä¸ªææéå°±è¿å true
 */
export function hasAnyPermissionTransform(
    permissionValue: string,
    allPermissionKeys: string[],
    expectedPermissionKeys: string[] | any
) {
    if(!expectedPermissionKeys || !helpers.isArray(expectedPermissionKeys)) {
        return false;
    }
    let result = false;
    expectedPermissionKeys.forEach(n => {
        const hasPermission = hasPermissionTransform(permissionValue, allPermissionKeys, n);
        if (hasPermission) {
            result = true;
            return false;
        }
    });
    return result;
}
